import React from 'react';


const TaskDesc = (props) => {
  return (
    <div className="pricing taskdesc" id="pricing">
      {props.min&& <h2 className="main-title">{props.min}</h2>}
      <div className="container">
        <div className="box popular">
          <div className="label taskdesc">Project Details</div>
          <div className="title heading box-title">{props.title}</div>
          
          <h2>{props.title}</h2>  
          <ul style={{"text-align":"center"}}>
          {props.des && <li>{props.des}</li>}
          {props.desc && <li>{props.desc}</li>}
          {props.abrev && <li>{props.abrev}</li>}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default TaskDesc;
